import { AppConfigService } from '@eucoms/common-components';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { TabLabel } from '@app/fallback-report/table-nav/table-nav.component';
import { Extensions } from './extensions';

/**
 * localService for fallback reports.
 * provides:
 * - tabs to render
 * - endpoint to render for the current tab
 * - opCo extensions sufficient to render the opCo's tables
 */
@Injectable()
export class FallbackReportService {
  private extensions = Extensions;
  opCo = this.appConfig.config.opCo;

  tabs: Array<TabLabel>;
  selectTabSubject: Subject<TabLabel> = new Subject<TabLabel>();

  endpointKey: string;
  private _endpoint: string;
  get endpoint() {
    return this._endpoint;
  }
  set endpoint(value: string) {
    this._endpoint = value;
    this.endpointKey = Object.keys(this.DataEndpoint).find(key => this.DataEndpoint[key] === value);
  }

  private _isShowMore = false;
  get isShowMore() {
    return this._isShowMore;
  }
  set isShowMore(value: boolean) {
    this._isShowMore = value;
  }

  private _aceMoreData = [];
  get aceMoreData() {
    return this._aceMoreData;
  }
  set aceMoreData(value: any) {
    this._aceMoreData = value;
  }

  DataFields: { [endpoint: string]: Array<string> /* field definitions */ };
  TabLabels: Array<TabLabel> = [];
  TableRowHeaders: { [endpoint: string]: Array<string> /* field definitions */ };
  TableCelStyles: { [endpoint: string]: { [datafield: string]: number /* tab style enum*/ } };
  DataEndpoint: { [endpoint: string]: string /* uri path */ };
  TableStyle: { [endpoint: string]: number /* index */ };

  constructor(private appConfig: AppConfigService) {
    this.visit(this.appConfig.config.opCo);
  }

  visit(opCo: string) {
    this.extensions[opCo]().accept(this);
  }

  get isBGE(): boolean {
    return this.opCo === 'BGE';
  }

  get isComEd(): boolean {
    return this.opCo === 'ComEd';
  }

  get isPECO(): boolean {
    return this.opCo === 'PECO';
  }

  get isACE(): boolean {
    return this.opCo === 'ACE';
  }

  get isDPL(): boolean {
    return this.opCo === 'DPL';
  }

  get isPEPCO(): boolean {
    return this.opCo === 'PEPCO';
  }
}
